button.gm-ui-hover-effect {
  visibility: hidden !important;
}

.gm-style .gm-style-iw-c {
  padding: 0 !important;
  border-radius: 24px !important;
}

.gm-style-iw .gm-style-iw-d {
  overflow: auto !important;
}

.gm-style .gm-style-iw-tc {
  display: none !important;
}
